import { useMemo } from 'react';

import { useShowEvent } from '@givebacks/api/store';
import { Stack } from 'ui';

import { EventDateCard } from '../CalendarSection/CalendarSection';

const IncludedEventDates = ({
  eventDates,
  causeId,
  eventId,
}: {
  eventDates?: string[];
  causeId: string;
  eventId: string;
}) => {
  const { data: event } = useShowEvent({ eventId, causeId });

  const _eventDates = useMemo(() => {
    if (!eventDates) return null;
    if (eventDates.includes('*')) {
      return event?.event_dates;
    }
    return event?.event_dates.filter((eventDate) => eventDates.includes(eventDate.uuid));
  }, [event?.event_dates, eventDates]);

  const eventDatesList = useMemo(() => {
    return _eventDates?.map((eventDate) => {
      return (
        <EventDateCard key={eventDate.uuid} eventDate={eventDate} showInventoryStatus={false} />
      );
    });
  }, [_eventDates]);

  return <Stack>{eventDatesList}</Stack>;
};

export { IncludedEventDates };
